import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { useRouterHistoryBack } from 'src/hooks/useRouterHistoryBack';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import styles from './DocsPage.module.scss';
const sx = classNames.bind(styles);

const docsOptions = [
  { label: '18 U.S.C. 2257 Exemption', url: '18_U_S_C_2257_Exemption.pdf' },
  { label: 'Anti-Modern Slavery and Human Trafficking Statement', url: 'Anti-Modern_Slavery_and_Human_Trafficking_Statement.pdf' },
  { label: 'Blocked Content Policy', url: 'Blocked_Content_Policy.pdf' },
  { label: 'Complaint Policy', url: 'Complaint_Policy.pdf' },
  { label: 'Content Management Policy', url: 'Content_Management_Policy.pdf' },
  { label: 'Content Removal Policy', url: 'Content_Removal_Policy.pdf' },
  { label: 'Cookies Policy', url: 'Cookies_Policy.pdf' },
  { label: 'DMCA Policy', url: 'DMCA_Policy.pdf' },
  { label: 'Privacy Policy', url: 'Privacy_Policy.pdf' },
  { label: 'Terms & Conditions', url: 'Terms_&_Conditions.pdf' },
  { label: 'Underage Policy', url: 'Underage_Policy.pdf' },
];
export default function DocsPage() {
  const historyBack = useRouterHistoryBack();

  useEffect(() => {
    const originalTitle = document.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    const metaTitle = document.querySelector('meta[name="title"]');
    const ogTitles = Array.from(
      document.querySelectorAll('meta[property="og:title"]')
    );
    const ogDescriptions = Array.from(
      document.querySelectorAll('meta[property="og:description"]')
    );
    const twitterTitles = Array.from(
      document.querySelectorAll('meta[name="twitter:title"]')
    );
    const twitterDescriptions = Array.from(
      document.querySelectorAll('meta[property="twitter:description"]')
    );
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }

    const originalValues = {
      title: originalTitle,
      description: metaDescription?.getAttribute('content') || '',
      titleMeta: metaTitle?.getAttribute('content') || '',
      ogTitles: ogTitles.map((el) => el.getAttribute('content') || ''),
      ogDescriptions: ogDescriptions.map(
        (el) => el.getAttribute('content') || ''
      ),
      twitterTitles: twitterTitles.map(
        (el) => el.getAttribute('content') || ''
      ),
      twitterDescriptions: twitterDescriptions.map(
        (el) => el.getAttribute('content') || ''
      ),
      canonicalHref: canonicalLink.href,
    };

    document.title = 'Legal information - Romantic AI';
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Legal information about Romantic AI App'
      );
    }
    if (metaTitle) {
      metaTitle.setAttribute('content', 'Legal information - Romantic AI');
    }
    ogTitles.forEach((el) => {
      el.setAttribute('content', 'Legal information - Romantic AI');
    });
    ogDescriptions.forEach((el) => {
      el.setAttribute('content', 'Legal information about Romantic AI App');
    });
    twitterTitles.forEach((el) => {
      el.setAttribute('content', 'Legal information - Romantic AI');
    });
    twitterDescriptions.forEach((el) => {
      el.setAttribute('content', 'Legal information about Romantic AI App');
    });
    canonicalLink.href = `${window.location.origin}/documents`;

    return () => {
      document.title = originalValues.title;
      if (metaDescription && originalValues.description) {
        metaDescription.setAttribute('content', originalValues.description);
      }
      if (metaTitle && originalValues.titleMeta) {
        metaTitle.setAttribute('content', originalValues.titleMeta);
      }
      ogTitles.forEach((el, i) => {
        if (originalValues.ogTitles[i]) {
          el.setAttribute('content', originalValues.ogTitles[i]);
        }
      });
      ogDescriptions.forEach((el, i) => {
        if (originalValues.ogDescriptions[i]) {
          el.setAttribute('content', originalValues.ogDescriptions[i]);
        }
      });
      twitterTitles.forEach((el, i) => {
        if (originalValues.twitterTitles[i]) {
          el.setAttribute('content', originalValues.twitterTitles[i]);
        }
      });
      twitterDescriptions.forEach((el, i) => {
        if (originalValues.twitterDescriptions[i]) {
          el.setAttribute('content', originalValues.twitterDescriptions[i]);
        }
      });
      if (canonicalLink) {
        canonicalLink.href = originalValues.canonicalHref || '';
      }
    };
  }, []);

  return (
    <div className={sx('container')}>
      <div className={sx('main')}>
        <div className={sx('title')}>
          <div className={sx('back-button')}>
            <Button
              variant="texted"
              size="sm"
              color="secondary"
              onClick={() => historyBack()}
            >
              <Icon name="Back" />
            </Button>
          </div>
          <h3>Legal information</h3>
        </div>
        <div className={sx('list')}>
          {docsOptions.map((item) => (
            <a
              href={`/assets/documents/${item.url}`}
              target="_blank"
              rel="noreferrer"
              className={sx('item')}
            >
              <Button variant="outlined" fuild className={sx('item-button')}>
                {item.label}
              </Button>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
